import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgxScannerQrcodeModule, LOAD_WASM } from 'ngx-scanner-qrcode';
import { ScannerComponent } from './scanner.component';
import { CommonModule } from '@angular/common';
import { Logger } from 'src/app/angular-wallet-base/services/logger.service';

/**
* this scanner component to repalce Browser-scanner component,
* because of new Wallet Connect QR code does not work
*/

// Necessary to solve the problem of losing internet connection
LOAD_WASM().subscribe((res: any) => Logger.warn(`load_wasm ${res}`));

@NgModule({
  imports:      [ 
    FormsModule,
    CommonModule, 
    NgxScannerQrcodeModule 
  ],
  declarations: [ ScannerComponent ],
  bootstrap:    [ ScannerComponent ]
})
export class ScannerModule { }
